import axios from "axios";
import Cookies from "js-cookie";
import camelCaseKeys from "camelcase-keys";
import projectConfig from "~/config";

const injectInterceptors = (instance: typeof vrachApi) => {
  instance.interceptors.request.use(
    (config) => {
      if (config.headers) {
        config.headers["access_token"] = Cookies.get("access_token");
      }

      return config;
    },
    (reason) => {
      return Promise.reject(reason);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      if (response.data) {
        response.data = camelCaseKeys(response.data, { deep: true });
      }

      return response;
    },
    (reason) => {
      return Promise.reject(reason);
    }
  );
};

const createInstance = (name: "vrach" | "egis" | "onlinezdrav") => {
  const instance = axios.create({ baseURL: projectConfig.api.endpoints[name] });
  injectInterceptors(instance);
  return instance;
};

export const vrachApi = createInstance("vrach");

export const egisApi = createInstance("egis");

export const onlinezdravApi = createInstance("onlinezdrav");
